// A viewer can create nothing, and an unsettled read reports zero rows before
// the answer is known, which would flash an add tile on a stocked workspace.
export const offersDocsAddTile = ({
	ready,
	role,
}: {
	ready: boolean
	role: string | null | undefined
}): boolean => ready && Boolean(role) && role !== "VIEWER"
